import Convert from './modules/Convert'
import ObjectTools from './modules/ObjectTools'
import StringTools from './modules/StringTools'
import PostDataTools from "@/plugin/Tools/modules/PostDataTools";
import FileTool from "@/plugin/Tools/modules/FileTool";

class Tools {
    constructor() {
        this._v = '1.0'
        this._author = 'yaaynn'
        this._email = 'yaaynn@gmail.com'
    }
    get v() {
        return this._v
    }
    get version() {
        return this._v
    }
    get author () {
        return this._author
    }
    get email () {
        return this.email
    }
    static get () {
        return new Tools()
    }

    get Convert () {
        return new Convert()
    }
    get ObjectTools () {
        return new ObjectTools()
    }
    get StringTools () {
        return new StringTools()
    }
    get PostDataTools () {
        return new PostDataTools()
    }
    get FileTool () {
        return new FileTool()
    }
}
export default Tools